<template>
  <div id="Dashboard"  class="container is-fluid">
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet">

    <!-- Header -->
    <HeroContainer title="Sales Chart Dashboard" />

    <section id="filters" style="display:flex; justify-content:center;">
      <div style="width:500px" >
        
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Group by</label>
          </div>
          <div class="field-body">
            <div class="field">
              <span class="select">
                <select id="period" v-model="period" >
                  <option disabled hidden value="" style="color:grey;">Period</option>
                  <option value='day'>Day</option>
                  <option value='week'>Week</option>
                  <option value='month'>Month</option>
                  <option value='quarter'>Quarter</option>
                </select>
              </span>
            </div>
          </div>
        </div>
        
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Period</label>
          </div>
          <div class="field-body">
            <div class="field has-addons" >
              <p class="control">
                <span class="select">
                  <select id="date_range" 
                    v-model="date_range" @change="change_date(date_range)">
                    <option disabled hidden value="" style="color:grey;">Date Presets</option>
                    <option value='today'>Today</option>
                    <option value='week'>Week</option>
                    <option value='this_month'>This Month</option>
                    <option value='prev_month'>Prev Month</option>
                    <option value='this_quarter'>This Quarter</option>
                    <option value='prev_quarter'>Prev Quarter</option>
                    <option value='this_year'>This Year</option>
                    <option value='prev_year'>Prev Year</option>
                    <option value='all'>All</option>
                    <option disabled hidden value='custom'>Custom</option>
                  </select>
                </span>
              </p>
              <p class="control  is-expanded">
                  <VueDatePicker v-model="range" :enable-time-picker="false" range/>
              </p>
            </div>
          </div>
        </div>
          
        <div class="buttons is-right">
          <button @click='reset' class="button is-small is-white">Reset</button>
          <button @click='ajax_get_dashboard' class="button is-info">Filter</button>
        </div>
      </div>
    </section>

    <section id="plot_data">
      <PlotlyFigure
        :plot_data="plotData"
        :layout="layout"
        :options="options"
        v-on:plot_click='plot_click'
        :key="figureKey"
        >
      </PlotlyFigure>
    </section>

    <section id="dashboard_data" v-if="queryData.data.length>0">
      <DataTable2 
        
        :raw_data="queryData"
        :name="'dash_sales_detail'"
        :columns_from_parent="[
          {
            label: 'Part',
            field: 'part_number',
            type: 'text',
          },
          {
            label: 'Description',
            field: 'description',
            type: 'text',
          },
          {
            label: 'Invoice',
            field: 'invoice',
            type: 'text',
          },
          {
            label: 'Margin',
            field: 'margin',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('0,0,0,0,0.00%')},
          },
          {
            label: 'Company PO',
            field: 'company_po_number',
            type: 'text',
          },
          {
            label: 'Profit',
            field: 'profit',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Unit Cost',
            field: 'unit_cost',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Unit Price',
            field: 'unit_price',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Total Cost',
            field: 'total_cost',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Total Price',
            field: 'total_price',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Bill Name',
            field: 'bill_name',
            type: 'text',
          },
          {
            label: 'Vendor',
            field: 'vendor_name',
            type: 'text',
          },
          {
            label: 'Dept Name',
            field: 'dept_name',
            type: 'text',
          },
          {
            label: 'Orig PO',
            field: 'original_po_number',
            type: 'text',
          },
          {
            label: 'Qty Invoiced',
            field: 'qty_invoiced',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('0,0,0,0,0')},
          },
          {
            label: 'Reference',
            field: 'reference',
            type: 'text',
          },
          {
            label: 'Invoice Date',
            field: 'invoice_date',
            type: 'text',
            formatFn: function(value) {return value.split('T')[0]},
          },
          {
            label: 'Post Date',
            field: 'post_date',
            type: 'text',
            formatFn: function(value) {return value.split('T')[0]},
          },
          {
            label: 'Time Created',
            field: 'time_created',
            type: 'text',
            formatFn: function(value) {return value.split('T')[0]},
          },
        ]"
      />
      <div class="buttons is-right">
        <button class="button is-info"
          style="margin: 0.5em 0 0 0"
          @click="$emit('download-csv', [queryData.data, 'SalesChartDashboard', null])">
          Download CSV
        </button>
      </div>
    </section>
  </div>
</template>


<script>
import DataTable2 from '@/components/shared/DataTable2.vue';
import PlotlyFigure from '@/components/shared/Plotly.vue';
import moment from 'moment';
import HeroContainer from '@/components/shared/HeroContainer.vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import { getDates } from '@/helpers/dates.js'
import {
  DASHBOARD_MARGIN_DETAIL,
  DASHBOARD_SALES_CHART
} from '@/data/url';

export default {
  name: 'DashboardSalesChartOld',
  components: {
    DataTable2,
    PlotlyFigure,
    HeroContainer,
    VueDatePicker
  },
  computed:{
    queryData(){
      let raw_query = [...this.queryDataRaw]
      if(Object.keys(raw_query).length == 0){
        return {site:'',data:[]}
      }
      return {site:'', data: raw_query,}
    },
    plotData(){
      let data = [{type:'scatter', name:'Sales', x:[], y:[], line: {shape: 'spline'},}, 
                  {type:'scatter',  name:'POs', yaxis: 'y2', x:[], y:[], line: {shape: 'spline'},},
                  {type:'scatter',  name:'Invoices', yaxis: 'y2', x:[], y:[], line: {shape: 'spline'},}, 
                ]
      if (Object.prototype.hasOwnProperty.call(this.plotDataRaw, 'sales')){
        let sales_data = this.plotDataRaw.sales
        for(let sales of sales_data){
            // Sales
            data[0].x.push(sales.period)
            data[0].y.push(sales.dollars)
            // POs
            data[1].x.push(sales.period)
            data[1].y.push(sales.pos)
            // Invoices
            data[2].x.push(sales.period)
            data[2].y.push(sales.invoices)
        }
      }
      return data
    },
  },
  data: function(){
    return {
      numeral: require('numeral'),
      figureKey: 0,
      period: 'week',
      period_last_filtered: 'week',
      date_range: 'this_quarter',
      range: [
        moment().startOf('quarter').toDate(),
        moment().endOf('quarter').toDate()
      ],
      queryDataRaw: [],
      plotDataRaw: [],
      layout: {
        legend: {
          x: 0,
          y: 1.3
        },
        yaxis: {
          title: {
            text: 'Sales',
            font: {
              size: 18,
              color: '#1f77b4'
            }
          },
          rangemode: 'tozero',
          },
        yaxis2: {
          title: {
            text: 'POs and Invoices',
            font: {
              size: 18,
            }
          },
          rangemode: 'tozero',
          overlaying: 'y',
          side: 'right'
        }
      },
      options : {
        displayModeBar: false,
        responsive: true
      },
    };
  },
  mounted: function(){
    this.ajax_get_dashboard()
  },
  watch: {
    plotData:
      function(){
        // Change key to force the component to re-render
        // otherwise it will have height=0
        this.figureKey += 1
      }
  },
  methods: {
    getDates,
    plot_click(click_data){
      let date = click_data.points[0].x
      let period =  this.period_last_filtered

      let dt = moment.utc(date)
      let dt2 = moment.utc(dt).endOf(period)
      this.ajax_get_detail(dt.toISOString(), dt2.toISOString())
    },
    reset(){
      this.queryDataRaw = []
      this.plotDataRaw = [],
      this.period = 'week'
      this.period_last_filtered = 'week',
      this.date_range=  'this_quarter'
      this.range = [
        moment().startOf('quarter').toDate(),
        moment().endOf('quarter').toDate()
      ]
    },
    change_date(date_range){
      let range = this.getDates(date_range)
      if(range){
        this.range = range
      }
    },
    set_searching(is_searching){
      this.searchStore.set_ajax_searching(is_searching)
    },
    filter_records(){
      this.ajax_get_dashboard(this.filter_customer, this.filter_user)
    },
    ajax_get_dashboard(){
      this.queryDataRaw = []
      this.plotDataRaw = []
      this.period_last_filtered = this.period
      let url = DASHBOARD_SALES_CHART
      let begin_date = moment.utc(this.range[0]).format('YYYY-MM-DD')
      let end_date = moment.utc(this.range[1]).endOf('day').format('YYYY-MM-DD')
      this.set_searching(true)
      let this_vue = this
      function set_dash(this_vue, data){
        this_vue.plotDataRaw = data
      }
      fetch(url, {
        method:'POST',
        body: JSON.stringify({begin_date: begin_date, end_date: end_date, period: this.period, }),
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_dash(this_vue, res.data)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
    ajax_get_detail(begin_date, end_date){
      this.queryDataRaw = []
      let url = DASHBOARD_MARGIN_DETAIL
      this.set_searching(true)
      let this_vue = this
      function set_detail(this_vue, data){
        this_vue.queryDataRaw = data.sales
      }
      fetch(url, {
        method:'POST',
        body: JSON.stringify({begin_date: begin_date, end_date: end_date, }),
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_detail(this_vue, res.data)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
  }
};

</script>
